/* eslint-disable no-console */

import { Vue } from 'vue-property-decorator'
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      Vue.prototype.$logger.log(
        'App is being served from cache by a service worker.\n' + 'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      Vue.prototype.$logger.log('Service worker has been registered.')
    },
    cached() {
      Vue.prototype.$logger.log('Content has been cached for offline use.')
    },
    updatefound() {
      Vue.prototype.$logger.log('New content is downloading.')
    },
    updated() {
      Vue.prototype.$logger.log('New content is available; please refresh.')
    },
    offline() {
      Vue.prototype.$logger.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      Vue.prototype.$logger.error('Error during service worker registration:', error)
    },
  })
}
